<template>
    <div class="card">
        <div class="card-body">
            <h4 class="text-muted">{{$t(data.label)}}</h4>
            <div class="row">
                <div class="col">{{data.text || ''}}</div>
                <div class="col-auto text-right">
                    <money v-if="data.money" :value="data.value || 0"></money>
                    <span v-else>{{data.value || 0}}</span>
                    <span v-if="data.units">{{$t('units')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Money from '@/components/Money.vue';

export default {
    props: { data: Object },
    components: {
        Money,
    },
    name: "TopperCard"
}
</script>

<style scoped>

</style>
